import { tableStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryTable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

tableStyles.container = {
    css: css`
        overflow: auto;
        margin-top: 20px;
    `,
};
tableStyles.dataTableBody = {
    css: css`
        td span[class^="TypographyStyle"] {
            font-size: ${TYPOGRAPHY.size.base};
        }
    `,
};
tableStyles.dataTableHead = {
    css: css`
        span[class^="TypographyStyle"] {
            color: ${COLORS.text.main};
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    span[class^="TypographyStyle"] {
                        font-size: 12px;
                    }
                `,
                css`
                    span[class^="TypographyStyle"] {
                        font-size: 12px;
                    }
                `,
                css`
                    span[class^="TypographyStyle"] {
                        font-size: 12px;
                    }
                `,
                null,
                null,
            ])}
    `,
};
tableStyles.invoiceNumberHeader = {
    css: css`
        white-space: nowrap !important;
        > button {
            justify-content: center;
        }
    `,
};
tableStyles.invoiceNumberCell = {
    css: css`
        span {
            color: ${COLORS.text.link} !important;
            &:hover {
                text-decoration: underline !important;
                text-decoration-color: ${COLORS.text.link} !important;
            }
        }
        > button {
            justify-content: center;
        }
    `,
};
tableStyles.invoiceDateHeader = {
    css: css`
        white-space: nowrap !important;
        > button {
            justify-content: center;
        }
    `,
};
tableStyles.termsHeader = {
    css: css`
        white-space: nowrap !important;
        > button {
            justify-content: center;
        }
    `,
};
tableStyles.dueDateHeader = {
    css: css`
        white-space: nowrap !important;
        > button {
            justify-content: center;
        }
    `,
};
tableStyles.shipToHeader = {
    css: css`
        white-space: nowrap !important;
        > button {
            justify-content: center;
        }
    `,
};
tableStyles.poNumberHeader = {
    css: css`
        white-space: nowrap !important;
        > button {
            justify-content: center;
        }
    `,
};
tableStyles.statusHeader = {
    css: css`
        white-space: nowrap !important;
        > button {
            justify-content: center;
        }
    `,
};
tableStyles.totalHeader = {
    css: css`
        white-space: nowrap !important;
        > button {
            justify-content: center;
        }
    `,
};
tableStyles.currentBalanceHeader = {
    css: css`
        white-space: nowrap !important;
        > button {
            justify-content: center;
            svg {
                margin-left: -5px !important; /* Adjust this to move the arrow left */
            }
        }
    `,
};
